import React from 'react';
import { Check } from '@mui/icons-material';
import { GalleryStyles as styles } from './chat.tailwind';

const FileUploadProgress = ({ file, currentFile, progress, uploadedFiles }) => {
  const isCurrentFile = currentFile === file.name;
  const isUploaded = uploadedFiles.includes(file.name);
  
  const getStatus = () => {
    if (isUploaded) return { text: 'Uploaded', progress: 100 };
    if (isCurrentFile) return { text: 'Uploading...', progress };
    return { text: 'Waiting...', progress: 0 };
  };
  
  const { text, progress: currentProgress } = getStatus();
  
  return (
    <div className={styles.progresMainContainer}>
      <div className={styles.progresTextMainContainer}>
        <span className={styles.progresTextContainer}>
          {text}
          {isUploaded && <Check size={16} className="text-green-500" />}
        </span>
        <span className={styles.currentProgress}>{currentProgress}%</span>
      </div>
      
      <div className={styles.progressBarMainContainer}>
        <div 
          className={` ${styles.progressBar} ${isUploaded ? 'bg-green-500' : 'bg-[#DDBA73]'} `}
          style={{ 
            transform: `translateX(-${100 - currentProgress}%)`,
            width: '100%'
          }}
        />
      </div>
    </div>
  );
};

export default FileUploadProgress;